export enum OrganisationType {
    PRODUCT_PROVIDER = 'PRODUCT_PROVIDER',
    PRODUCT_TYPE_ASSOCIATION = 'PRODUCT_TYPE_ASSOCIATION',
    CERTIFICATION_OFFICE = 'CERTIFICATION_OFFICE',
    CERTIFICATION_PROVIDER = 'CERTIFICATION_PROVIDER',
    DATASPACE_PARTICIPANT = 'DATASPACE_PARTICIPANT'
}
